<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-listar #ctrl URL="cliente?id=2" titulo="Cliente / Personas"></app-listar>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<div class="contenedor columns " style="height:100%; ">
  <div class="column is-2 is-hidden-mobile menu-izquierda">

    <!-- Menu izquierda del modulo enviroment" -->
    <app-sistema-menu-aside></app-sistema-menu-aside>
  </div>
  <div class="column" style="padding:0px;">
    <div style="background: #FFF; border-radius: 1em; ">

      <!-- Opciones y busqueda -->
      <app-tabla-opciones [ctrl]="ctrl"></app-tabla-opciones>

      <div id="exportar_datos" style="overflow-y:auto; overflow-x: hidden; display:block; height: 78.4vh;">

        <!--Tabla -->
        <table class="table is-striped  is-fullwidth" *ngIf="ctrl.tipo_grid && !ctrl.cargando ">
          <thead>
            <tr>
              <th>
                <abbr>Usuario</abbr>
              </th>
              <th>Nombre</th>
              <th>Correo</th>
              <th>Banco</th>
              <th width="1%" class="no_pdf">Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of ctrl.dato; let i=index">
              <th style="vertical-align: middle;">{{ item.username }}</th>
              <td style="vertical-align: middle;">{{ item.nombre }} </td>
              <td style="vertical-align: middle;">{{ item.email }}</td>
              <td style="vertical-align: middle;">

                <span class="tag is-success">
                  Banco: {{ item.banco }} Cuenta: {{ item.cuenta_bancaria }} Clabe: {{ item.clabe_interbancaria }}
                </span>

              </td>
              <td style="vertical-align: middle;" class="has-text-centered no_pdf">
                <!-- acciones -->
                <app-tabla-acciones [item]="item" [index]="i" [ctrl]="ctrl" class="level-left"></app-tabla-acciones>
              </td>

            </tr>
            <tr *ngIf="ctrl.dato.length == 0">
              <td colspan="5" style="vertical-align: middle; color:#888;">Esta lista está vacía.</td>
            </tr>
          </tbody>

        </table>

        <!--Lista -->
        <span *ngIf="!ctrl.tipo_grid && !ctrl.cargando" class="lista_lista">
          <div class="box" *ngFor="let item of ctrl.dato; let i=index" style="margin-bottom:0.1rem;"
            [style.background]="i%2 == 0 ? '#fafafa' : '#ffffff'">
            <article class="media">
              <div class="media-left">
                <figure class="image is-64x64">
                  <img [src]="item.foto ? ctrl.API_PATH+'/adjunto/personas/'+item.foto : item.avatar" alt="Image">
                </figure>
              </div>
              <div class="media-content">
                <div class="content">
                  <p>
                    <strong style="font-size:12pt">{{item.nombre}}</strong>
                    <small>{{ item.personas }}</small>
                    <small>{{item.updated_at}}</small>
                    <br>
                    <strong style="color:darkgreen"> {{ item.email }}</strong>
                    <span class="tag is-success">
                      Banco: {{ item.banco }} Cuenta: {{ item.cuenta_bancaria }} Clabe: {{ item.clabe_interbancaria }}
                    </span>
                  </p>
                </div>
                <nav class="level is-mobile" style="float:right">
                  <div class="level-left">

                    <!-- acciones -->
                    <app-tabla-acciones [item]="item" [index]="i" [ctrl]="ctrl" class="level-left"></app-tabla-acciones>
                  </div>
                </nav>
              </div>
            </article>
          </div>
        </span>
      </div>
      <!-- Paginación para la lista  -->
      <app-paginacion [ctrl]="ctrl"></app-paginacion>

    </div>
  </div>
</div>
